import { Component, Input } from "@angular/core";
import { DistributionRuleModel } from "../../../../shared/models/cart/distribution-rule.model";

@Component({
    selector: "pcg-ng-distributors-list",
    template: require('./distributors-list.component.html')
})
export class DistributorsListComponent {
    @Input() public distributionRules: Array<DistributionRuleModel>;

    public isSingleLink(): boolean {
        return this.distributionRules && this.distributionRules.length === 1;
    }
}
